import Examine from '../views/Logs/Examine.vue';
let Logs = [
  {
    path: 'Examine',
    name: '查看日志',
    component: Examine
  }
];

export default Logs;
